module.exports = {
      id: "mynews-usage",
      viewBox: "0 0 13.581 13.581",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#mynews",
      toString: function () {
        return this.url;
      }
    }